<template>
    <div>
<!--      <el-button-group>-->
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="mini"-->
<!--          icon="el-icon-edit"-->
<!--          v-if="getMenuButton('A').show"-->
<!--          @click="fromLoad('add')"-->
<!--        >{{getMenuButton('A').text}}</el-button>-->
<!--      </el-button-group>-->
      <el-table
        :data="table"
        v-loading="loading"
        stripe
        size="mini"
      >
        <el-table-column sortable
          :show-overflow-tooltip="true"
          align="center"
          prop="seqno"
          label="序号"
          min-width="80"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          header-align="left"
          prop="detailItemName"
          label="明细登记项名称"
          min-width="180"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          header-align="left"
          prop="detailItemValue"
          label="明细登记项值"
          min-width="150"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          header-align="left"
          prop="detailItemRemark"
          label="备注信息"
          min-width="180"
        ></el-table-column>
        <el-table-column v-if="!disabled" label="操作" width="80" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button
              @click="fromLoad('edit',scope.row)"
              type="text"
              size="mini"
            >编辑</el-button>
          </template>
        </el-table-column>
        <div slot="empty">
          <div class="mt-60">
            <img src="/image/static/img/nodata.png" />
            <p class="no-data">暂无数据！</p>
          </div>
        </div>
      </el-table>
      <el-dialog
        ref="formDialog"
        :title="formOption.title"
        :visible.sync="formOption.dialogFormVisible"
        :before-close="cancel"
        :close-on-click-modal="false"
        width="950px"
      >
        <page-detail ref="form" @success="saveSuccess"></page-detail>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel" size="small">取 消</el-button>
          <el-button
            type="primary"
            @click="save"
            size="small"
            v-show="formOption.dialogSaveBtnVisible"
          >保 存</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
// import { getList } from '@api/projectManager/infoSample'

export default {
  components: {
    'PageDetail': () => import('./components/detail')
  },
  props: {
    loading: {
      default: false
    },
    params: {
      default: null,
      type: Object
    },
    disabled: {
      default: true,
      type: Boolean
    },
    autoLoad: {
      default: false,
      type: Boolean
    }
  },
  watch: {
    params: {
      handler () {
        if (this.autoLoad) {
          this.getData()
        }
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      // 表单设置
      formOption: {
        title: '',
        dialogFormVisible: false,
        dialogSaveBtnVisible: true
      },
      table: []
      // params: {
      //   masterCategoryCode: '',
      //   prjCategoryCode: '',
      //   prjCode: '5a400927-9441-11ea-a357-000c29540cfd'
      // }
    }
  },
  // mounted () {
  //   this.getData()
  // },
  methods: {
    load (params) {
      this.getData(params)
    },
    getData (form) {
    this.$api.sampleListApi({
        ...form || this.params
      }).then(res => {
        this.loading = false
        this.table = res.body.data
      }).catch(() => {
        this.loading = false
      })
    },
    // 加载表单
    fromLoad (ref, val = { }) {
      const opt = {
        add: '新增',
        edit: '编辑',
        detail: '详情'
      }
      // 设置标题
      this.formOption.title = opt[ref]
      // 控制保存按钮显隐
      if (ref === 'detail') {
        this.formOption.dialogSaveBtnVisible = false
      } else {
        this.formOption.dialogSaveBtnVisible = true
      }
      // 显示表单
      this.formOption.dialogFormVisible = true
      setTimeout(() => {
        // this.$refs.form.fromLoad(ref, JSON.parse(JSON.stringify(val)))
        let obj = {
          prjInfoSampleCode: val.prjInfoSampleCode,
          prjCode: val.prjCode,
          seqno: val.seqno,
          detailItemName: val.detailItemName,
          detailItemValue: val.detailItemValue,
          detailItemRemark: val.detailItemRemark
        }
        // 调用组件表单加载方法
        this.$refs.form.fromLoad(ref, obj)
      }, 0)
    },
    save () {
      this.$refs.form.save()
    },
    saveSuccess () {
      this.getData()
      this.cancel()
    },
    cancel () {
      this.formOption.dialogFormVisible = false
    }
  }
}
</script>
